
import Panel from './Panel';
import PanelHeader from './PanelHeader';
import PanelBody from './PanelBody';
import PanelFooter from './PanelFooter';
import PanelTitle from './PanelTitle';
import PanelMore from './PanelMore';

Panel.Header = PanelHeader;
Panel.Body = PanelBody;
Panel.Footer = PanelFooter;
Panel.Title = PanelTitle;
Panel.More = PanelMore;

export default Panel;
